import {
  promotionClaimOutcome,
  isPromotionClaimStatus,
  type PromotionClaimStatus,
} from '@b1fr0st/contracts/domain/promo-claim-status';

export type ClaimBadgeTone = 'success' | 'warning' | 'info' | 'danger' | 'muted';

/**
 * Keyed on the shared status union, so a status svc-promo starts writing stops
 * this file from compiling rather than falling through to muted. `revoked` did
 * exactly that fall-through until #372 made those rows visible at all.
 */
const CLAIM_TONE: Record<PromotionClaimStatus, ClaimBadgeTone> = {
  pending: 'info',
  approved: 'info',
  active: 'info',
  completed: 'success',
  released: 'success',
  rejected: 'danger',
  forfeited: 'danger',
  revoked: 'danger',
  cancelled: 'danger',
};

export function claimTone(status: string): ClaimBadgeTone {
  return isPromotionClaimStatus(status) ? CLAIM_TONE[status] : 'muted';
}

/**
 * Whether the granted amount on a claim may be shown as money the player got.
 *
 * `grantedAmount` survives a forfeit, a rejection and an admin clawback
 * unchanged, so the column alone is not evidence of anything. An unknown status
 * answers false — a build that has not heard of a status must not announce money
 * on its behalf.
 */
export function claimAmountIsCredited(status: string | null | undefined): boolean {
  return promotionClaimOutcome(status) === 'credited';
}

/** Whether the claim ended with the money taken back off the player. */
export function claimAmountIsWithheld(status: string | null | undefined): boolean {
  return promotionClaimOutcome(status) === 'withheld';
}
